import React, { createContext, useContext, useState, useCallback } from 'react';

// ── Loader Context ───────────────────────────
const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

// ── Loader Provider ──────────────────────────
export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState('Please wait...');

  const showLoader = useCallback((msg = 'Please wait...') => {
    setMessage(msg);
    setProgress(0);
    setLoading(true);

    // Simulate progress bar
    let p = 0;
    const interval = setInterval(() => {
      p += Math.random() * 15;
      if (p >= 90) {
        clearInterval(interval);
        p = 90;
      }
      setProgress(Math.min(p, 90));
    }, 200);

    return interval;
  }, []);

  const hideLoader = useCallback((interval) => {
    if (interval) clearInterval(interval);
    setProgress(100);
    setTimeout(() => {
      setLoading(false);
      setProgress(0);
    }, 300);
  }, []);

  return (
    <LoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
      {children}
      {loading && (
        <>
          {/* Top Progress Bar */}
          <div style={{
            position: 'fixed', top: 0, left: 0, right: 0,
            height: 3, zIndex: 99999,
            background: 'rgba(255,255,255,0.2)',
          }}>
            <div style={{
              height: '100%',
              width: `${progress}%`,
              background: 'linear-gradient(90deg, #c8973a, #e8b55a)',
              transition: 'width 0.2s ease',
              borderRadius: '0 2px 2px 0',
              boxShadow: '0 0 8px rgba(200,151,58,0.6)',
            }} />
          </div>

          {/* Full Screen Overlay */}
          <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(15, 36, 64, 0.45)',
            zIndex: 99998,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            backdropFilter: 'blur(2px)',
          }}>
            {/* Loader Card */}
            <div style={{
              background: 'white',
              borderRadius: 14,
              padding: '28px 36px',
              display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 16,
              boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
              minWidth: 200,
            }}>
              {/* Spinner */}
              <div style={{
                width: 44, height: 44,
                border: '3px solid #e2e8f0',
                borderTop: '3px solid #1a3a5c',
                borderRadius: '50%',
                animation: 'bps-spin 0.75s linear infinite',
              }} />
              {/* Message */}
              <div style={{
                fontSize: 14, fontWeight: 500,
                color: '#1e293b',
                fontFamily: "'Inter', sans-serif",
                textAlign: 'center',
              }}>
                {message}
              </div>
            </div>
          </div>

          {/* Spinner Animation */}
          <style>{`
            @keyframes bps-spin {
              to { transform: rotate(360deg); }
            }
          `}</style>
        </>
      )}
    </LoaderContext.Provider>
  );
};
